define([
  "backbone",
  "jquery",
  "marionette",
  "underscore",
  "messaging/messenger",
  "./taskDenialNextStepsView",
  "modules/tasks/tasksModel",
], function (Backbone, $, Marionette, _, Messenger, TaskDenialNextStepsView, TaskModel) {
  "use strict";

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.region = options.region;
      this.name = "taskDenialNextSteps";
    },
    show: function (task) {
      this.task = task;
      this.taskSteps = task.steps();
      this.collection = new Backbone.Collection();
      const kbId = Messenger.reqres.request("active:kb");
      this.collection.departments = Messenger.reqres.request("kb:departments", {
        kbId: kbId,
        includeUsers: true,
      });
      this._processTaskSteps();
      this.view = new TaskDenialNextStepsView.denialNextStepsView({ collection: this.collection });
      this.view.on("itemview:change:denialNextStep", this._onChangeDenialNextStep, this);
      this.showRegion(this.view, { loading: true, entity: this.collection.departments });
    },
    commitData: function () {
      return true;
    },
    _onChangeDenialNextStep: function (itemView, options) {
      const value = options.value;
      const model = options.model;
      model.set("denialNextStep", value);
      model.taskStep.set("denialNextStep", value);
      // Must update the denialNextStep for all steps with the same order,
      // because Localized steps do not have their own interface for specifying
      // what the denial step is
      const order = model.get("order");
      this.taskSteps.forEach(function (ts) {
        if (ts.get("order") == order) {
          ts.set("denialNextStep", value);
        }
      });
    },
    _createModel: function (taskStep, taskStepAssignee, assigneeIndex) {
      const assigneeData = _.extend(
        {
          departmentName: "",
          readOnly: false,
          userName: "",
        },
        taskStep.attributes,
        taskStepAssignee.attributes,
      );
      switch (taskStep.get("status")) {
        case TaskModel.STATUS.FAILED:
        case TaskModel.STATUS.COMPLETED:
          assigneeData.readOnly = true;
      }
      const assignees = taskStep.assignees();
      assigneeData.firstAssignee = assigneeIndex === 0;
      assigneeData.lastAssignee = assigneeIndex === assignees.length - 1;
      const departmentId = taskStepAssignee.get("departmentId");
      if (departmentId) {
        const departments = this.collection.departments;
        const department = departments.get(taskStepAssignee.get("departmentId"));
        assigneeData.departmentName = department.get("name");
        if (taskStepAssignee.get("allUsers")) {
          assigneeData.userName = $.t("task.wizard.allUsers");
        } else {
          const user = department.users().findWhere({ userId: taskStepAssignee.get("userId") });
          if (user) {
            assigneeData.userName = user.get("userName");
          }
        }
      }
      const model = new Backbone.Model(assigneeData, { parse: true });
      model.taskStep = taskStep;
      model.taskStepAssignee = taskStepAssignee;
      return model;
    },
    _processTaskSteps: function () {
      const models = [];
      const taskSteps = this.taskSteps;
      taskSteps.each(function (taskStep) {
        if (taskStep.get("languageId") <= 0) {
          const assignees = taskStep.assignees();
          assignees.each(function (taskStepAssignee, assigneeIndex) {
            const model = this._createModel(taskStep, taskStepAssignee, assigneeIndex);
            models.push(model);
          }, this);
        }
      }, this);
      this.collection.reset(models);
    },
  });
});
